module.exports = __webpack_public_path__ + "static/media/best western-logo.0efd9b84.svg";